import _defineProperty from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
function e(e) {
  function t(e, t) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = t;
  }
  return t.prototype = new Error(), t.prototype.name = e, t.prototype.constructor = t, t;
}
var t = e("LaunchDarklyUnexpectedResponseError"),
  n = e("LaunchDarklyInvalidEnvironmentIdError"),
  r = e("LaunchDarklyInvalidUserError"),
  o = e("LaunchDarklyInvalidEventKeyError"),
  i = e("LaunchDarklyInvalidArgumentError"),
  a = e("LaunchDarklyFlagFetchError");
for (var s = {
    LDUnexpectedResponseError: t,
    LDInvalidEnvironmentIdError: n,
    LDInvalidUserError: r,
    LDInvalidEventKeyError: o,
    LDInvalidArgumentError: i,
    LDInvalidDataError: e("LaunchDarklyInvalidDataError"),
    LDFlagFetchError: a,
    LDTimeoutError: e("LaunchDarklyTimeoutError"),
    isHttpErrorRecoverable: function isHttpErrorRecoverable(e) {
      return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
    }
  }, c = function c(e) {
    var t = m(e),
      n = t[0],
      r = t[1];
    return 3 * (n + r) / 4 - r;
  }, u = function u(e) {
    var t,
      n,
      r = m(e),
      o = r[0],
      i = r[1],
      a = new g(function (e, t, n) {
        return 3 * (t + n) / 4 - n;
      }(0, o, i)),
      s = 0,
      c = i > 0 ? o - 4 : o;
    for (n = 0; n < c; n += 4) t = f[e.charCodeAt(n)] << 18 | f[e.charCodeAt(n + 1)] << 12 | f[e.charCodeAt(n + 2)] << 6 | f[e.charCodeAt(n + 3)], a[s++] = t >> 16 & 255, a[s++] = t >> 8 & 255, a[s++] = 255 & t;
    2 === i && (t = f[e.charCodeAt(n)] << 2 | f[e.charCodeAt(n + 1)] >> 4, a[s++] = 255 & t);
    1 === i && (t = f[e.charCodeAt(n)] << 10 | f[e.charCodeAt(n + 1)] << 4 | f[e.charCodeAt(n + 2)] >> 2, a[s++] = t >> 8 & 255, a[s++] = 255 & t);
    return a;
  }, l = function l(e) {
    for (var t, n = e.length, r = n % 3, o = [], i = 16383, a = 0, s = n - r; a < s; a += i) o.push(h(e, a, a + i > s ? s : a + i));
    1 === r ? (t = e[n - 1], o.push(d[t >> 2] + d[t << 4 & 63] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], o.push(d[t >> 10] + d[t >> 4 & 63] + d[t << 2 & 63] + "="));
    return o.join("");
  }, d = [], f = [], g = "undefined" != typeof Uint8Array ? Uint8Array : Array, v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = 0; p < 64; ++p) d[p] = v[p], f[v.charCodeAt(p)] = p;
function m(e) {
  var t = e.length;
  if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
}
function h(e, t, n) {
  for (var r, o, i = [], a = t; a < n; a += 3) r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(d[(o = r) >> 18 & 63] + d[o >> 12 & 63] + d[o >> 6 & 63] + d[63 & o]);
  return i.join("");
}
f["-".charCodeAt(0)] = 62, f["_".charCodeAt(0)] = 63;
var y = {
    byteLength: c,
    toByteArray: u,
    fromByteArray: l
  },
  w = Array.isArray,
  b = Object.keys,
  k = Object.prototype.hasOwnProperty,
  E = function e(t, n) {
    if (t === n) return !0;
    if (t && n && "object" == typeof t && "object" == typeof n) {
      var r,
        o,
        i,
        a = w(t),
        s = w(n);
      if (a && s) {
        if ((o = t.length) != n.length) return !1;
        for (r = o; 0 != r--;) if (!e(t[r], n[r])) return !1;
        return !0;
      }
      if (a != s) return !1;
      var c = t instanceof Date,
        u = n instanceof Date;
      if (c != u) return !1;
      if (c && u) return t.getTime() == n.getTime();
      var l = t instanceof RegExp,
        d = n instanceof RegExp;
      if (l != d) return !1;
      if (l && d) return t.toString() == n.toString();
      var f = b(t);
      if ((o = f.length) !== b(n).length) return !1;
      for (r = o; 0 != r--;) if (!k.call(n, f[r])) return !1;
      for (r = o; 0 != r--;) if (!e(t[i = f[r]], n[i])) return !1;
      return !0;
    }
    return t != t && n != n;
  };
var D = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function x(e) {
  var t = unescape(encodeURIComponent(e));
  return y.fromByteArray(function (e) {
    var t = [];
    for (var _n = 0; _n < e.length; _n++) t.push(e.charCodeAt(_n));
    return t;
  }(t));
}
function C(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var P,
  S = {
    appendUrlPath: function appendUrlPath(e, t) {
      return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
    },
    base64URLEncode: function base64URLEncode(e) {
      return x(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    },
    btoa: x,
    clone: function clone(e) {
      return JSON.parse(JSON.stringify(e));
    },
    deepEquals: function deepEquals(e, t) {
      return E(e, t);
    },
    extend: function extend() {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      return e.reduce(function (e, t) {
        return _objectSpread(_objectSpread({}, e), t);
      }, {});
    },
    getLDUserAgentString: function getLDUserAgentString(e) {
      var t = e.version || "?";
      return e.userAgent + "/" + t;
    },
    objectHasOwnProperty: C,
    onNextTick: function onNextTick(e) {
      setTimeout(e, 0);
    },
    sanitizeContext: function sanitizeContext(e) {
      if (!e) return e;
      var t;
      return null !== e.kind && void 0 !== e.kind || D.forEach(function (n) {
        var r = e[n];
        void 0 !== r && "string" != typeof r && (t = t || _objectSpread({}, e), t[n] = String(r));
      }), t || e;
    },
    transformValuesToVersionedValues: function transformValuesToVersionedValues(e) {
      var t = {};
      for (var _n2 in e) C(e, _n2) && (t[_n2] = {
        value: e[_n2],
        version: 0
      });
      return t;
    },
    transformVersionedValuesToValues: function transformVersionedValuesToValues(e) {
      var t = {};
      for (var _n3 in e) C(e, _n3) && (t[_n3] = e[_n3].value);
      return t;
    },
    wrapPromiseCallback: function wrapPromiseCallback(e, t) {
      var n = e.then(function (e) {
        return t && setTimeout(function () {
          t(null, e);
        }, 0), e;
      }, function (e) {
        if (!t) return Promise.reject(e);
        setTimeout(function () {
          t(e, null);
        }, 0);
      });
      return t ? void 0 : n;
    }
  },
  I = new Uint8Array(16);
function O() {
  if (!P && !(P = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return P(I);
}
var T = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function L(e) {
  return "string" == typeof e && T.test(e);
}
for (var U, R, A = [], j = 0; j < 256; ++j) A.push((j + 256).toString(16).substr(1));
function F(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    n = (A[e[t + 0]] + A[e[t + 1]] + A[e[t + 2]] + A[e[t + 3]] + "-" + A[e[t + 4]] + A[e[t + 5]] + "-" + A[e[t + 6]] + A[e[t + 7]] + "-" + A[e[t + 8]] + A[e[t + 9]] + "-" + A[e[t + 10]] + A[e[t + 11]] + A[e[t + 12]] + A[e[t + 13]] + A[e[t + 14]] + A[e[t + 15]]).toLowerCase();
  if (!L(n)) throw TypeError("Stringified UUID is invalid");
  return n;
}
var N = 0,
  $ = 0;
function V(e) {
  if (!L(e)) throw TypeError("Invalid UUID");
  var t,
    n = new Uint8Array(16);
  return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
}
function M(e, t, n) {
  function r(e, r, o, i) {
    if ("string" == typeof e && (e = function (e) {
      e = unescape(encodeURIComponent(e));
      for (var t = [], n = 0; n < e.length; ++n) t.push(e.charCodeAt(n));
      return t;
    }(e)), "string" == typeof r && (r = V(r)), 16 !== r.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var a = new Uint8Array(16 + e.length);
    if (a.set(r), a.set(e, r.length), (a = n(a))[6] = 15 & a[6] | t, a[8] = 63 & a[8] | 128, o) {
      i = i || 0;
      for (var s = 0; s < 16; ++s) o[i + s] = a[s];
      return o;
    }
    return F(a);
  }
  try {
    r.name = e;
  } catch (e) {}
  return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
}
function H(e) {
  return 14 + (e + 64 >>> 9 << 4) + 1;
}
function q(e, t) {
  var n = (65535 & e) + (65535 & t);
  return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
}
function z(e, t, n, r, o, i) {
  return q((a = q(q(t, e), q(r, i))) << (s = o) | a >>> 32 - s, n);
  var a, s;
}
function K(e, t, n, r, o, i, a) {
  return z(t & n | ~t & r, e, t, o, i, a);
}
function _(e, t, n, r, o, i, a) {
  return z(t & r | n & ~r, e, t, o, i, a);
}
function J(e, t, n, r, o, i, a) {
  return z(t ^ n ^ r, e, t, o, i, a);
}
function B(e, t, n, r, o, i, a) {
  return z(n ^ (t | ~r), e, t, o, i, a);
}
var G = M("v3", 48, function (e) {
    if ("string" == typeof e) {
      var t = unescape(encodeURIComponent(e));
      e = new Uint8Array(t.length);
      for (var n = 0; n < t.length; ++n) e[n] = t.charCodeAt(n);
    }
    return function (e) {
      for (var t = [], n = 32 * e.length, r = "0123456789abcdef", o = 0; o < n; o += 8) {
        var i = e[o >> 5] >>> o % 32 & 255,
          a = parseInt(r.charAt(i >>> 4 & 15) + r.charAt(15 & i), 16);
        t.push(a);
      }
      return t;
    }(function (e, t) {
      e[t >> 5] |= 128 << t % 32, e[H(t) - 1] = t;
      for (var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, a = 0; a < e.length; a += 16) {
        var s = n,
          c = r,
          u = o,
          l = i;
        n = K(n, r, o, i, e[a], 7, -680876936), i = K(i, n, r, o, e[a + 1], 12, -389564586), o = K(o, i, n, r, e[a + 2], 17, 606105819), r = K(r, o, i, n, e[a + 3], 22, -1044525330), n = K(n, r, o, i, e[a + 4], 7, -176418897), i = K(i, n, r, o, e[a + 5], 12, 1200080426), o = K(o, i, n, r, e[a + 6], 17, -1473231341), r = K(r, o, i, n, e[a + 7], 22, -45705983), n = K(n, r, o, i, e[a + 8], 7, 1770035416), i = K(i, n, r, o, e[a + 9], 12, -1958414417), o = K(o, i, n, r, e[a + 10], 17, -42063), r = K(r, o, i, n, e[a + 11], 22, -1990404162), n = K(n, r, o, i, e[a + 12], 7, 1804603682), i = K(i, n, r, o, e[a + 13], 12, -40341101), o = K(o, i, n, r, e[a + 14], 17, -1502002290), n = _(n, r = K(r, o, i, n, e[a + 15], 22, 1236535329), o, i, e[a + 1], 5, -165796510), i = _(i, n, r, o, e[a + 6], 9, -1069501632), o = _(o, i, n, r, e[a + 11], 14, 643717713), r = _(r, o, i, n, e[a], 20, -373897302), n = _(n, r, o, i, e[a + 5], 5, -701558691), i = _(i, n, r, o, e[a + 10], 9, 38016083), o = _(o, i, n, r, e[a + 15], 14, -660478335), r = _(r, o, i, n, e[a + 4], 20, -405537848), n = _(n, r, o, i, e[a + 9], 5, 568446438), i = _(i, n, r, o, e[a + 14], 9, -1019803690), o = _(o, i, n, r, e[a + 3], 14, -187363961), r = _(r, o, i, n, e[a + 8], 20, 1163531501), n = _(n, r, o, i, e[a + 13], 5, -1444681467), i = _(i, n, r, o, e[a + 2], 9, -51403784), o = _(o, i, n, r, e[a + 7], 14, 1735328473), n = J(n, r = _(r, o, i, n, e[a + 12], 20, -1926607734), o, i, e[a + 5], 4, -378558), i = J(i, n, r, o, e[a + 8], 11, -2022574463), o = J(o, i, n, r, e[a + 11], 16, 1839030562), r = J(r, o, i, n, e[a + 14], 23, -35309556), n = J(n, r, o, i, e[a + 1], 4, -1530992060), i = J(i, n, r, o, e[a + 4], 11, 1272893353), o = J(o, i, n, r, e[a + 7], 16, -155497632), r = J(r, o, i, n, e[a + 10], 23, -1094730640), n = J(n, r, o, i, e[a + 13], 4, 681279174), i = J(i, n, r, o, e[a], 11, -358537222), o = J(o, i, n, r, e[a + 3], 16, -722521979), r = J(r, o, i, n, e[a + 6], 23, 76029189), n = J(n, r, o, i, e[a + 9], 4, -640364487), i = J(i, n, r, o, e[a + 12], 11, -421815835), o = J(o, i, n, r, e[a + 15], 16, 530742520), n = B(n, r = J(r, o, i, n, e[a + 2], 23, -995338651), o, i, e[a], 6, -198630844), i = B(i, n, r, o, e[a + 7], 10, 1126891415), o = B(o, i, n, r, e[a + 14], 15, -1416354905), r = B(r, o, i, n, e[a + 5], 21, -57434055), n = B(n, r, o, i, e[a + 12], 6, 1700485571), i = B(i, n, r, o, e[a + 3], 10, -1894986606), o = B(o, i, n, r, e[a + 10], 15, -1051523), r = B(r, o, i, n, e[a + 1], 21, -2054922799), n = B(n, r, o, i, e[a + 8], 6, 1873313359), i = B(i, n, r, o, e[a + 15], 10, -30611744), o = B(o, i, n, r, e[a + 6], 15, -1560198380), r = B(r, o, i, n, e[a + 13], 21, 1309151649), n = B(n, r, o, i, e[a + 4], 6, -145523070), i = B(i, n, r, o, e[a + 11], 10, -1120210379), o = B(o, i, n, r, e[a + 2], 15, 718787259), r = B(r, o, i, n, e[a + 9], 21, -343485551), n = q(n, s), r = q(r, c), o = q(o, u), i = q(i, l);
      }
      return [n, r, o, i];
    }(function (e) {
      if (0 === e.length) return [];
      for (var t = 8 * e.length, n = new Uint32Array(H(t)), r = 0; r < t; r += 8) n[r >> 5] |= (255 & e[r / 8]) << r % 32;
      return n;
    }(e), 8 * e.length));
  }),
  W = G;
function X(e, t, n, r) {
  switch (e) {
    case 0:
      return t & n ^ ~t & r;
    case 1:
    case 3:
      return t ^ n ^ r;
    case 2:
      return t & n ^ t & r ^ n & r;
  }
}
function Q(e, t) {
  return e << t | e >>> 32 - t;
}
var Y = M("v5", 80, function (e) {
    var t = [1518500249, 1859775393, 2400959708, 3395469782],
      n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if ("string" == typeof e) {
      var r = unescape(encodeURIComponent(e));
      e = [];
      for (var o = 0; o < r.length; ++o) e.push(r.charCodeAt(o));
    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
    e.push(128);
    for (var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), c = 0; c < a; ++c) {
      for (var u = new Uint32Array(16), l = 0; l < 16; ++l) u[l] = e[64 * c + 4 * l] << 24 | e[64 * c + 4 * l + 1] << 16 | e[64 * c + 4 * l + 2] << 8 | e[64 * c + 4 * l + 3];
      s[c] = u;
    }
    s[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = 8 * (e.length - 1) & 4294967295;
    for (var d = 0; d < a; ++d) {
      for (var f = new Uint32Array(80), g = 0; g < 16; ++g) f[g] = s[d][g];
      for (var v = 16; v < 80; ++v) f[v] = Q(f[v - 3] ^ f[v - 8] ^ f[v - 14] ^ f[v - 16], 1);
      for (var p = n[0], m = n[1], h = n[2], y = n[3], w = n[4], b = 0; b < 80; ++b) {
        var k = Math.floor(b / 20),
          E = Q(p, 5) + X(k, m, h, y) + w + t[k] + f[b] >>> 0;
        w = y, y = h, h = Q(m, 30) >>> 0, m = p, p = E;
      }
      n[0] = n[0] + p >>> 0, n[1] = n[1] + m >>> 0, n[2] = n[2] + h >>> 0, n[3] = n[3] + y >>> 0, n[4] = n[4] + w >>> 0;
    }
    return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, 255 & n[0], n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, 255 & n[1], n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, 255 & n[2], n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, 255 & n[3], n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, 255 & n[4]];
  }),
  Z = Y;
var ee = Object.freeze({
  __proto__: null,
  v1: function v1(e, t, n) {
    var r = t && n || 0,
      o = t || new Array(16),
      i = (e = e || {}).node || U,
      a = void 0 !== e.clockseq ? e.clockseq : R;
    if (null == i || null == a) {
      var s = e.random || (e.rng || O)();
      null == i && (i = U = [1 | s[0], s[1], s[2], s[3], s[4], s[5]]), null == a && (a = R = 16383 & (s[6] << 8 | s[7]));
    }
    var c = void 0 !== e.msecs ? e.msecs : Date.now(),
      u = void 0 !== e.nsecs ? e.nsecs : $ + 1,
      l = c - N + (u - $) / 1e4;
    if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || c > N) && void 0 === e.nsecs && (u = 0), u >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    N = c, $ = u, R = a;
    var d = (1e4 * (268435455 & (c += 122192928e5)) + u) % 4294967296;
    o[r++] = d >>> 24 & 255, o[r++] = d >>> 16 & 255, o[r++] = d >>> 8 & 255, o[r++] = 255 & d;
    var f = c / 4294967296 * 1e4 & 268435455;
    o[r++] = f >>> 8 & 255, o[r++] = 255 & f, o[r++] = f >>> 24 & 15 | 16, o[r++] = f >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
    for (var g = 0; g < 6; ++g) o[r + g] = i[g];
    return t || F(o);
  },
  v3: W,
  v4: function v4(e, t, n) {
    var r = (e = e || {}).random || (e.rng || O)();
    if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
      n = n || 0;
      for (var o = 0; o < 16; ++o) t[n + o] = r[o];
      return t;
    }
    return F(r);
  },
  v5: Z,
  NIL: "00000000-0000-0000-0000-000000000000",
  version: function version(e) {
    if (!L(e)) throw TypeError("Invalid UUID");
    return parseInt(e.substr(14, 1), 16);
  },
  validate: L,
  stringify: F,
  parse: V
});
var te = ["debug", "info", "warn", "error", "none"];
var ne = {
  commonBasicLogger: function commonBasicLogger(e, t) {
    if (e && e.destination && "function" != typeof e.destination) throw new Error("destination for basicLogger was set to a non-function");
    function n(e) {
      return function (t) {
        console && console[e] && console[e].call(console, t);
      };
    }
    var r = e && e.destination ? [e.destination, e.destination, e.destination, e.destination] : [n("log"), n("info"), n("warn"), n("error")],
      o = !(!e || !e.destination),
      i = e && void 0 !== e.prefix && null !== e.prefix ? e.prefix : "[LaunchDarkly] ";
    var a = 1;
    if (e && e.level) for (var _t = 0; _t < te.length; _t++) te[_t] === e.level && (a = _t);
    function s(e, n, a) {
      if (a.length < 1) return;
      var s;
      var c = o ? n + ": " + i : i;
      if (1 !== a.length && t) {
        var _e2 = _toConsumableArray(a);
        _e2[0] = c + _e2[0], s = t.apply(void 0, _toConsumableArray(_e2));
      } else s = c + a[0];
      try {
        r[e](s);
      } catch (e) {
        console && console.log && console.log("[LaunchDarkly] Configured logger's " + n + " method threw an exception: " + e);
      }
    }
    var c = {};
    var _loop = function _loop() {
      var t = te[_e3];
      if ("none" !== t) if (_e3 < a) c[t] = function () {};else {
        var _n4 = _e3;
        c[t] = function () {
          s(_n4, t, arguments);
        };
      }
    };
    for (var _e3 = 0; _e3 < te.length; _e3++) {
      _loop();
    }
    return c;
  },
  validateLogger: function validateLogger(e) {
    te.forEach(function (t) {
      if ("none" !== t && (!e[t] || "function" != typeof e[t])) throw new Error("Provided logger instance must support logger." + t + "(...) method");
    });
  }
};
function re(e) {
  return e && e.message ? e.message : "string" == typeof e || e instanceof String ? e : JSON.stringify(e);
}
var oe = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var ie = {
  bootstrapInvalid: function bootstrapInvalid() {
    return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
  },
  bootstrapOldFormat: function bootstrapOldFormat() {
    return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + oe;
  },
  clientInitialized: function clientInitialized() {
    return "LaunchDarkly client initialized";
  },
  clientNotReady: function clientNotReady() {
    return "LaunchDarkly client is not ready";
  },
  debugEnqueueingEvent: function debugEnqueueingEvent(e) {
    return 'enqueueing "' + e + '" event';
  },
  debugPostingDiagnosticEvent: function debugPostingDiagnosticEvent(e) {
    return "sending diagnostic event (" + e.kind + ")";
  },
  debugPostingEvents: function debugPostingEvents(e) {
    return "sending " + e + " events";
  },
  debugStreamDelete: function debugStreamDelete(e) {
    return 'received streaming deletion for flag "' + e + '"';
  },
  debugStreamDeleteIgnored: function debugStreamDeleteIgnored(e) {
    return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
  },
  debugStreamPatch: function debugStreamPatch(e) {
    return 'received streaming update for flag "' + e + '"';
  },
  debugStreamPatchIgnored: function debugStreamPatchIgnored(e) {
    return 'received streaming update for flag "' + e + '" but ignored due to version check';
  },
  debugStreamPing: function debugStreamPing() {
    return "received ping message from stream";
  },
  debugPolling: function debugPolling(e) {
    return "polling for feature flags at " + e;
  },
  debugStreamPut: function debugStreamPut() {
    return "received streaming update for all flags";
  },
  deprecated: function deprecated(e, t) {
    return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
  },
  environmentNotFound: function environmentNotFound() {
    return "Environment not found. Double check that you specified a valid environment/client-side ID." + oe;
  },
  environmentNotSpecified: function environmentNotSpecified() {
    return "No environment/client-side ID was specified." + oe;
  },
  errorFetchingFlags: function errorFetchingFlags(e) {
    return "Error fetching flag settings: " + re(e);
  },
  eventCapacityExceeded: function eventCapacityExceeded() {
    return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
  },
  eventWithoutContext: function eventWithoutContext() {
    return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
  },
  httpErrorMessage: function httpErrorMessage(e, t, n) {
    return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + t + " - " + (s.isHttpErrorRecoverable(e) ? n : "giving up permanently");
  },
  httpUnavailable: function httpUnavailable() {
    return "Cannot make HTTP requests in this environment." + oe;
  },
  identifyDisabled: function identifyDisabled() {
    return "identify() has no effect here; it must be called on the main client instance";
  },
  inspectorMethodError: function inspectorMethodError(e, t) {
    return "an inspector: \"".concat(t, "\" of type: \"").concat(e, "\" generated an exception");
  },
  invalidContentType: function invalidContentType(e) {
    return 'Expected application/json content type but got "' + e + '"';
  },
  invalidData: function invalidData() {
    return "Invalid data received from LaunchDarkly; connection may have been interrupted";
  },
  invalidInspector: function invalidInspector(e, t) {
    return "an inspector: \"".concat(t, "\" of an invalid type (").concat(e, ") was configured");
  },
  invalidKey: function invalidKey() {
    return "Event key must be a string";
  },
  invalidMetricValue: function invalidMetricValue(e) {
    return "The track function was called with a non-numeric \"metricValue\" (".concat(e, "), only numeric metric values are supported.");
  },
  invalidContext: function invalidContext() {
    return "Invalid context specified." + oe;
  },
  invalidTagValue: function invalidTagValue(e) {
    return "Config option \"".concat(e, "\" must only contain letters, numbers, ., _ or -.");
  },
  localStorageUnavailable: function localStorageUnavailable(e) {
    return "local storage is unavailable: " + re(e);
  },
  networkError: function networkError(e) {
    return "network error" + (e ? " (" + e + ")" : "");
  },
  optionBelowMinimum: function optionBelowMinimum(e, t, n) {
    return 'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + n;
  },
  streamClosing: function streamClosing() {
    return "Closing stream connection";
  },
  streamConnecting: function streamConnecting(e) {
    return "Opening stream connection to " + e;
  },
  streamError: function streamError(e, t) {
    return "Error on stream connection: " + re(e) + ", will continue retrying after " + t + " milliseconds.";
  },
  tagValueTooLong: function tagValueTooLong(e) {
    return "Value of \"".concat(e, "\" was longer than 64 characters and was discarded.");
  },
  unknownCustomEventKey: function unknownCustomEventKey(e) {
    return 'Custom event "' + e + '" does not exist';
  },
  unknownOption: function unknownOption(e) {
    return 'Ignoring unknown config option "' + e + '"';
  },
  contextNotSpecified: function contextNotSpecified() {
    return "No context specified." + oe;
  },
  unrecoverableStreamError: function unrecoverableStreamError(e) {
    return "Error on stream connection ".concat(re(e), ", giving up permanently");
  },
  wrongOptionType: function wrongOptionType(e, t, n) {
    return 'Config option "' + e + '" should be of type ' + t + ", got " + n + ", using default value";
  },
  wrongOptionTypeBoolean: function wrongOptionTypeBoolean(e, t) {
    return 'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean";
  }
};
var ae = ne.validateLogger,
  se = {
    baseUrl: {
      default: "https://app.launchdarkly.com"
    },
    streamUrl: {
      default: "https://clientstream.launchdarkly.com"
    },
    eventsUrl: {
      default: "https://events.launchdarkly.com"
    },
    sendEvents: {
      default: !0
    },
    streaming: {
      type: "boolean"
    },
    sendLDHeaders: {
      default: !0
    },
    requestHeaderTransform: {
      type: "function"
    },
    sendEventsOnlyForVariation: {
      default: !1
    },
    useReport: {
      default: !1
    },
    evaluationReasons: {
      default: !1
    },
    eventCapacity: {
      default: 100,
      minimum: 1
    },
    flushInterval: {
      default: 2e3,
      minimum: 2e3
    },
    samplingInterval: {
      default: 0,
      minimum: 0
    },
    streamReconnectDelay: {
      default: 1e3,
      minimum: 0
    },
    allAttributesPrivate: {
      default: !1
    },
    privateAttributes: {
      default: []
    },
    bootstrap: {
      type: "string|object"
    },
    diagnosticRecordingInterval: {
      default: 9e5,
      minimum: 2e3
    },
    diagnosticOptOut: {
      default: !1
    },
    wrapperName: {
      type: "string"
    },
    wrapperVersion: {
      type: "string"
    },
    stateProvider: {
      type: "object"
    },
    application: {
      validator: function validator(e, t, n) {
        var r = {};
        t.id && (r.id = le("".concat(e, ".id"), t.id, n));
        t.version && (r.version = le("".concat(e, ".version"), t.version, n));
        return r;
      }
    },
    inspectors: {
      default: []
    }
  },
  ce = /^(\w|\.|-)+$/;
function ue(e) {
  return e && e.replace(/\/+$/, "");
}
function le(e, t, n) {
  if ("string" == typeof t && t.match(ce)) {
    if (!(t.length > 64)) return t;
    n.warn(ie.tagValueTooLong(e));
  } else n.warn(ie.invalidTagValue(e));
}
var de = {
  baseOptionDefs: se,
  validate: function validate(e, t, n, r) {
    var o = S.extend({
        logger: {
          default: r
        }
      }, se, n),
      i = {};
    function a(e) {
      S.onNextTick(function () {
        t && t.maybeReportError(new s.LDInvalidArgumentError(e));
      });
    }
    var c = S.extend({}, e || {});
    return function (e) {
      var t = e;
      Object.keys(i).forEach(function (e) {
        if (void 0 !== t[e]) {
          var _n5 = i[e];
          r && r.warn(ie.deprecated(e, _n5)), _n5 && (void 0 === t[_n5] && (t[_n5] = t[e]), delete t[e]);
        }
      });
    }(c), c = function (e) {
      var t = S.extend({}, e);
      return Object.keys(o).forEach(function (e) {
        void 0 !== t[e] && null !== t[e] || (t[e] = o[e] && o[e].default);
      }), t;
    }(c), c = function (e) {
      var t = S.extend({}, e),
        n = function n(e) {
          if (null === e) return "any";
          if (void 0 === e) return;
          if (Array.isArray(e)) return "array";
          var t = typeof e;
          return "boolean" === t || "string" === t || "number" === t || "function" === t ? t : "object";
        };
      return Object.keys(e).forEach(function (i) {
        var s = e[i];
        if (null != s) {
          var _c = o[i];
          if (void 0 === _c) a(ie.unknownOption(i));else {
            var _o = _c.type || n(_c.default),
              _u = _c.validator;
            if (_u) {
              var _n6 = _u(i, e[i], r);
              void 0 !== _n6 ? t[i] = _n6 : delete t[i];
            } else if ("any" !== _o) {
              var _e4 = _o.split("|"),
                _r = n(s);
              _e4.indexOf(_r) < 0 ? "boolean" === _o ? (t[i] = !!s, a(ie.wrongOptionTypeBoolean(i, _r))) : (a(ie.wrongOptionType(i, _o, _r)), t[i] = _c.default) : "number" === _r && void 0 !== _c.minimum && s < _c.minimum && (a(ie.optionBelowMinimum(i, s, _c.minimum)), t[i] = _c.minimum);
            }
          }
        }
      }), t.baseUrl = ue(t.baseUrl), t.streamUrl = ue(t.streamUrl), t.eventsUrl = ue(t.eventsUrl), t;
    }(c), ae(c.logger), c;
  },
  getTags: function getTags(e) {
    var t = {};
    return e && (e.application && void 0 !== e.application.id && null !== e.application.id && (t["application-id"] = [e.application.id]), e.application && void 0 !== e.application.version && null !== e.application.id && (t["application-version"] = [e.application.version])), t;
  }
};
var fe = S.getLDUserAgentString;
var ge = {
  getLDHeaders: function getLDHeaders(e, t) {
    if (t && !t.sendLDHeaders) return {};
    var n = {};
    n[e.userAgentHeaderName || "User-Agent"] = fe(e), t && t.wrapperName && (n["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
    var r = de.getTags(t),
      o = Object.keys(r);
    return o.length && (n["x-launchdarkly-tags"] = o.sort().map(function (e) {
      return Array.isArray(r[e]) ? r[e].sort().map(function (t) {
        return "".concat(e, "/").concat(t);
      }) : ["".concat(e, "/").concat(r[e])];
    }).reduce(function (e, t) {
      return e.concat(t);
    }, []).join(" ")), n;
  },
  transformHeaders: function transformHeaders(e, t) {
    return t && t.requestHeaderTransform ? t.requestHeaderTransform(_objectSpread({}, e)) : e;
  }
};
var ve = ee.v1,
  pe = ge.getLDHeaders,
  me = ge.transformHeaders;
var he = function he(e, t, n) {
  var r = S.extend({
      "Content-Type": "application/json"
    }, pe(e, n)),
    o = {};
  return o.sendEvents = function (t, o, i) {
    if (!e.httpRequest) return Promise.resolve();
    var a = JSON.stringify(t),
      c = i ? null : ve();
    return function t(u) {
      var l = i ? r : S.extend({}, r, {
        "X-LaunchDarkly-Event-Schema": "4",
        "X-LaunchDarkly-Payload-ID": c
      });
      return e.httpRequest("POST", o, me(l, n), a).promise.then(function (e) {
        if (e) return e.status >= 400 && s.isHttpErrorRecoverable(e.status) && u ? t(!1) : function (e) {
          var t = {
              status: e.status
            },
            n = e.header("date");
          if (n) {
            var _e5 = Date.parse(n);
            _e5 && (t.serverTime = _e5);
          }
          return t;
        }(e);
      }).catch(function () {
        return u ? t(!1) : Promise.reject();
      });
    }(!0).catch(function () {});
  }, o;
};
var ye = ne.commonBasicLogger;
function we(e) {
  return "string" == typeof e && "kind" !== e && e.match(/^(\w|\.|-)+$/);
}
function be(e) {
  return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var ke = {
  checkContext: function checkContext(e, t) {
    if (e) {
      if (t && (void 0 === e.kind || null === e.kind)) return void 0 !== e.key && null !== e.key;
      var _n7 = e.key,
        _r2 = void 0 === e.kind ? "user" : e.kind,
        _o2 = we(_r2),
        _i = "multi" === _r2 || null != _n7 && "" !== _n7;
      if ("multi" === _r2) {
        var _t2 = Object.keys(e).filter(function (e) {
          return "kind" !== e;
        });
        return _i && _t2.every(function (e) {
          return we(e);
        }) && _t2.every(function (t) {
          var n = e[t].key;
          return null != n && "" !== n;
        });
      }
      return _i && _o2;
    }
    return !1;
  },
  getContextKeys: function getContextKeys(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ye();
    if (!e) return;
    var n = {},
      r = e.kind,
      o = e.key;
    switch (r) {
      case void 0:
        n.user = "".concat(o);
        break;
      case "multi":
        Object.entries(e).filter(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
            e = _ref2[0];
          return "kind" !== e;
        }).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            e = _ref4[0],
            t = _ref4[1];
          t && t.key && (n[e] = t.key);
        });
        break;
      case null:
        t.warn("null is not a valid context kind: ".concat(e));
        break;
      case "":
        t.warn("'' is not a valid context kind: ".concat(e));
        break;
      default:
        n[r] = "".concat(o);
    }
    return n;
  },
  getContextKinds: function getContextKinds(e) {
    return e ? null === e.kind || void 0 === e.kind ? ["user"] : "multi" !== e.kind ? [e.kind] : Object.keys(e).filter(function (e) {
      return "kind" !== e;
    }) : [];
  },
  getCanonicalKey: function getCanonicalKey(e) {
    if (e) {
      if ((void 0 === e.kind || null === e.kind || "user" === e.kind) && e.key) return e.key;
      if ("multi" !== e.kind && e.key) return "".concat(e.kind, ":").concat(be(e.key));
      if ("multi" === e.kind) return Object.keys(e).sort().filter(function (e) {
        return "kind" !== e;
      }).map(function (t) {
        return "".concat(t, ":").concat(be(e[t].key));
      }).join(":");
    }
  }
};
var Ee = ke.getContextKinds;
var De = function De() {
  var e = {};
  var t = 0,
    n = 0,
    r = {},
    o = {};
  return e.summarizeEvent = function (e) {
    if ("feature" === e.kind) {
      var _i2 = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""),
        _a = r[_i2];
      var _s = o[e.key];
      _s || (_s = new Set(), o[e.key] = _s), function (e) {
        return e.context ? Ee(e.context) : e.contextKeys ? Object.keys(e.contextKeys) : [];
      }(e).forEach(function (e) {
        return _s.add(e);
      }), _a ? _a.count = _a.count + 1 : r[_i2] = {
        count: 1,
        key: e.key,
        version: e.version,
        variation: e.variation,
        value: e.value,
        default: e.default
      }, (0 === t || e.creationDate < t) && (t = e.creationDate), e.creationDate > n && (n = e.creationDate);
    }
  }, e.getSummary = function () {
    var e = {};
    var i = !0;
    for (var _i3 = 0, _Object$values = Object.values(r); _i3 < _Object$values.length; _i3++) {
      var _t3 = _Object$values[_i3];
      var _n8 = e[_t3.key];
      _n8 || (_n8 = {
        default: _t3.default,
        counters: [],
        contextKinds: _toConsumableArray(o[_t3.key])
      }, e[_t3.key] = _n8);
      var _r3 = {
        value: _t3.value,
        count: _t3.count
      };
      void 0 !== _t3.variation && null !== _t3.variation && (_r3.variation = _t3.variation), void 0 !== _t3.version && null !== _t3.version ? _r3.version = _t3.version : _r3.unknown = !0, _n8.counters.push(_r3), i = !1;
    }
    return i ? null : {
      startDate: t,
      endDate: n,
      features: e
    };
  }, e.clearSummary = function () {
    t = 0, n = 0, r = {}, o = {};
  }, e;
};
function xe(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Ce(e) {
  return (e.startsWith("/") ? e.substring(1) : e).split("/").map(function (e) {
    return e.indexOf("~") >= 0 ? e.replace(/~1/g, "/").replace(/~0/g, "~") : e;
  });
}
function Pe(e) {
  return !e.startsWith("/");
}
function Se(e, t) {
  var n = Pe(e),
    r = Pe(t);
  if (n && r) return e === t;
  if (n) {
    var _n9 = Ce(t);
    return 1 === _n9.length && e === _n9[0];
  }
  if (r) {
    var _n10 = Ce(e);
    return 1 === _n10.length && t === _n10[0];
  }
  return e === t;
}
function Ie(e) {
  return "/".concat(xe(e));
}
var Oe = {
  cloneExcluding: function cloneExcluding(e, t) {
    var n = [],
      r = {},
      o = [];
    var _loop2 = function _loop2() {
      var e = n.pop();
      if (t.some(function (t) {
        return Se(t, e.ptr);
      })) o.push(e.ptr);else {
        var _t4 = e.source[e.key];
        if (null === _t4) e.parent[e.key] = _t4;else if (Array.isArray(_t4)) e.parent[e.key] = _toConsumableArray(_t4);else if ("object" == typeof _t4) {
          if (e.visited.includes(_t4)) return 1; // continue
          e.parent[e.key] = {}, n.push.apply(n, _toConsumableArray(Object.keys(_t4).map(function (n) {
            return {
              key: n,
              ptr: (r = e.ptr, o = xe(n), "".concat(r, "/").concat(o)),
              source: _t4,
              parent: e.parent[e.key],
              visited: [].concat(_toConsumableArray(e.visited), [_t4])
            };
            var r, o;
          })));
        } else e.parent[e.key] = _t4;
      }
    };
    for (n.push.apply(n, _toConsumableArray(Object.keys(e).map(function (t) {
      return {
        key: t,
        ptr: Ie(t),
        source: e,
        parent: r,
        visited: [e]
      };
    }))); n.length;) {
      if (_loop2()) continue;
    }
    return {
      cloned: r,
      excluded: o.sort()
    };
  },
  compare: Se,
  literalToReference: Ie
};
var Te = function Te(e) {
  var t = {},
    n = e.allAttributesPrivate,
    r = e.privateAttributes || [],
    o = ["key", "kind", "_meta", "anonymous"],
    i = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"],
    a = function a(e, t) {
      if ("object" != typeof e || null === e || Array.isArray(e)) return;
      var _Oe$cloneExcluding = Oe.cloneExcluding(e, function (e, t) {
          return (n || t && e.anonymous ? Object.keys(e) : [].concat(_toConsumableArray(r), _toConsumableArray(e._meta && e._meta.privateAttributes || []))).filter(function (e) {
            return !o.some(function (t) {
              return Oe.compare(e, t);
            });
          });
        }(e, t)),
        i = _Oe$cloneExcluding.cloned,
        a = _Oe$cloneExcluding.excluded;
      return i.key = String(i.key), a.length && (i._meta || (i._meta = {}), i._meta.redactedAttributes = a), i._meta && (delete i._meta.privateAttributes, 0 === Object.keys(i._meta).length && delete i._meta), void 0 !== i.anonymous && (i.anonymous = !!i.anonymous), i;
    };
  return t.filter = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return void 0 === e.kind || null === e.kind ? a(function (e) {
      var t = _objectSpread(_objectSpread({}, e.custom || {}), {}, {
        kind: "user",
        key: e.key
      });
      void 0 !== e.anonymous && (t.anonymous = !!e.anonymous);
      for (var _i5 = 0, _i4 = i; _i5 < _i4.length; _i5++) {
        var _n11 = _i4[_i5];
        delete t[_n11], void 0 !== e[_n11] && null !== e[_n11] && (t[_n11] = String(e[_n11]));
      }
      return void 0 !== e.privateAttributeNames && null !== e.privateAttributeNames && (t._meta = t._meta || {}, t._meta.privateAttributes = e.privateAttributeNames.map(function (e) {
        return e.startsWith("/") ? Oe.literalToReference(e) : e;
      })), t;
    }(e), t) : "multi" === e.kind ? function (e, t) {
      var n = {
          kind: e.kind
        },
        r = Object.keys(e);
      for (var _i6 = 0, _r4 = r; _i6 < _r4.length; _i6++) {
        var _o3 = _r4[_i6];
        if ("kind" !== _o3) {
          var _r5 = a(e[_o3], t);
          _r5 && (n[_o3] = _r5);
        }
      }
      return n;
    }(e, t) : a(e, t);
  }, t;
};
var Le = ke.getContextKeys;
var Ue = function Ue(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var a = {},
    c = i || he(e, n, t),
    u = S.appendUrlPath(t.eventsUrl, "/events/bulk/" + n),
    l = De(),
    d = Te(t),
    f = t.samplingInterval,
    g = t.eventCapacity,
    v = t.flushInterval,
    p = t.logger;
  var m,
    h = [],
    y = 0,
    w = !1,
    b = !1;
  function k() {
    return 0 === f || 0 === Math.floor(Math.random() * f);
  }
  function E(e) {
    var t = S.extend({}, e);
    return "identify" === e.kind ? t.context = d.filter(e.context) : "feature" === e.kind ? t.context = d.filter(e.context, !0) : (t.contextKeys = Le(e.context, p), delete t.context), "feature" === e.kind && (delete t.trackEvents, delete t.debugEventsUntilDate), t;
  }
  function D(e) {
    h.length < g ? (h.push(e), b = !1) : (b || (b = !0, p.warn(ie.eventCapacityExceeded())), r && r.incrementDroppedEvents());
  }
  return a.enqueue = function (e) {
    if (w) return;
    var t = !1,
      n = !1;
    var r;
    if (l.summarizeEvent(e), "feature" === e.kind ? k() && (t = !!e.trackEvents, n = !!(r = e).debugEventsUntilDate && r.debugEventsUntilDate > y && r.debugEventsUntilDate > new Date().getTime()) : t = k(), t && D(E(e)), n) {
      var _t5 = S.extend({}, e, {
        kind: "debug"
      });
      _t5.context = d.filter(_t5.context), delete _t5.trackEvents, delete _t5.debugEventsUntilDate, D(_t5);
    }
  }, a.flush = function () {
    if (w) return Promise.resolve();
    var e = h,
      t = l.getSummary();
    return l.clearSummary(), t && (t.kind = "summary", e.push(t)), r && r.setEventsInLastBatch(e.length), 0 === e.length ? Promise.resolve() : (h = [], p.debug(ie.debugPostingEvents(e.length)), c.sendEvents(e, u).then(function (e) {
      e && (e.serverTime && (y = e.serverTime), s.isHttpErrorRecoverable(e.status) || (w = !0), e.status >= 400 && S.onNextTick(function () {
        o.maybeReportError(new s.LDUnexpectedResponseError(ie.httpErrorMessage(e.status, "event posting", "some events were dropped")));
      }));
    }));
  }, a.start = function () {
    var _e6 = function e() {
      a.flush(), m = setTimeout(_e6, v);
    };
    m = setTimeout(_e6, v);
  }, a.stop = function () {
    clearTimeout(m);
  }, a;
};
var Re = function Re(e) {
  var t = {},
    n = {};
  return t.on = function (e, t, r) {
    n[e] = n[e] || [], n[e] = n[e].concat({
      handler: t,
      context: r
    });
  }, t.off = function (e, t, r) {
    if (n[e]) for (var _o4 = 0; _o4 < n[e].length; _o4++) n[e][_o4].handler === t && n[e][_o4].context === r && (n[e] = n[e].slice(0, _o4).concat(n[e].slice(_o4 + 1)));
  }, t.emit = function (e) {
    if (!n[e]) return;
    var t = n[e].slice(0);
    for (var _e7 = 0; _e7 < t.length; _e7++) t[_e7].handler.apply(t[_e7].context, Array.prototype.slice.call(arguments, 1));
  }, t.getEvents = function () {
    return Object.keys(n);
  }, t.getEventListenerCount = function (e) {
    return n[e] ? n[e].length : 0;
  }, t.maybeReportError = function (t) {
    t && (n["error"] ? this.emit("error", t) : (e || console).error(t.message));
  }, t;
};
var Ae = "ready",
  je = "initialized",
  Fe = "failed";
var Ne = function Ne(e) {
  var t = !1,
    n = !1,
    r = null,
    o = null;
  var i = new Promise(function (t) {
    var _n12 = function n() {
      e.off(Ae, _n12), t();
    };
    e.on(Ae, _n12);
  }).catch(function () {});
  return {
    getInitializationPromise: function getInitializationPromise() {
      return o || (t ? Promise.resolve() : n ? Promise.reject(r) : (o = new Promise(function (t, n) {
        var _r6 = function r() {
            e.off(je, _r6), t();
          },
          _o5 = function o(t) {
            e.off(Fe, _o5), n(t);
          };
        e.on(je, _r6), e.on(Fe, _o5);
      }), o));
    },
    getReadyPromise: function getReadyPromise() {
      return i;
    },
    signalSuccess: function signalSuccess() {
      t || n || (t = !0, e.emit(je), e.emit(Ae));
    },
    signalFailure: function signalFailure(o) {
      t || n || (n = !0, r = o, e.emit(Fe, o), e.emit(Ae)), e.maybeReportError(o);
    }
  };
};
var $e = function $e(e, t, n, r) {
  var o = {};
  function i() {
    var e = "";
    var o = r.getContext();
    return o && (e = n || S.btoa(JSON.stringify(o))), "ld:" + t + ":" + e;
  }
  return o.loadFlags = function () {
    return e.get(i()).then(function (e) {
      if (null == e) return null;
      try {
        var _t6 = JSON.parse(e);
        if (_t6) {
          var _e8 = _t6.$schema;
          void 0 === _e8 || _e8 < 1 ? _t6 = S.transformValuesToVersionedValues(_t6) : delete _t6.$schema;
        }
        return _t6;
      } catch (e) {
        return o.clearFlags().then(function () {
          return null;
        });
      }
    });
  }, o.saveFlags = function (t) {
    var n = S.extend({}, t, {
      $schema: 1
    });
    return e.set(i(), JSON.stringify(n));
  }, o.clearFlags = function () {
    return e.clear(i());
  }, o;
};
var Ve = function Ve(e, t) {
  var n = {};
  var r = !1;
  var o = function o(e) {
    r || (r = !0, t.warn(ie.localStorageUnavailable(e)));
  };
  return n.isEnabled = function () {
    return !!e;
  }, n.get = function (t) {
    return new Promise(function (n) {
      e ? e.get(t).then(n).catch(function (e) {
        o(e), n(void 0);
      }) : n(void 0);
    });
  }, n.set = function (t, n) {
    return new Promise(function (r) {
      e ? e.set(t, n).then(function () {
        return r(!0);
      }).catch(function (e) {
        o(e), r(!1);
      }) : r(!1);
    });
  }, n.clear = function (t) {
    return new Promise(function (n) {
      e ? e.clear(t).then(function () {
        return n(!0);
      }).catch(function (e) {
        o(e), n(!1);
      }) : n(!1);
    });
  }, n;
};
var Me = S.appendUrlPath,
  He = S.base64URLEncode,
  qe = S.objectHasOwnProperty,
  ze = ge.getLDHeaders,
  Ke = ge.transformHeaders,
  _e = s.isHttpErrorRecoverable;
var Je = function Je(e, t, n, r) {
  var o = t.streamUrl,
    i = t.logger,
    a = {},
    s = Me(o, "/eval/" + n),
    c = t.useReport,
    u = t.evaluationReasons,
    l = t.streamReconnectDelay,
    d = ze(e, t);
  var f,
    g = !1,
    v = null,
    p = null,
    m = null,
    h = null,
    y = null,
    w = 0;
  function b() {
    var e = (t = function () {
      var e = l * Math.pow(2, w);
      return e > 3e4 ? 3e4 : e;
    }(), t - Math.trunc(.5 * Math.random() * t));
    var t;
    return w += 1, e;
  }
  function k(e) {
    if (e.status && "number" == typeof e.status && !_e(e.status)) return x(), i.error(ie.unrecoverableStreamError(e)), void (p && (clearTimeout(p), p = null));
    var t = b();
    g || (i.warn(ie.streamError(e, t)), g = !0), C(!1), x(), E(t);
  }
  function E(e) {
    p || (e ? p = setTimeout(D, e) : D());
  }
  function D() {
    var r;
    p = null;
    var a = "";
    var l = {
      headers: d,
      readTimeoutMillis: 3e5
    };
    if (e.eventSourceFactory) {
      null != h && (a = "h=" + h), c ? e.eventSourceAllowsReport ? (r = s, l.method = "REPORT", l.headers["Content-Type"] = "application/json", l.body = JSON.stringify(m)) : (r = Me(o, "/ping/" + n), a = "") : r = s + "/" + He(JSON.stringify(m)), l.headers = Ke(l.headers, t), u && (a = a + (a ? "&" : "") + "withReasons=true"), r = r + (a ? "?" : "") + a, x(), i.info(ie.streamConnecting(r)), f = new Date().getTime(), v = e.eventSourceFactory(r, l);
      for (var _e9 in y) qe(y, _e9) && v.addEventListener(_e9, y[_e9]);
      v.onerror = k, v.onopen = function () {
        w = 0;
      };
    }
  }
  function x() {
    v && (i.info(ie.streamClosing()), v.close(), v = null);
  }
  function C(e) {
    f && r && r.recordStreamInit(f, !e, new Date().getTime() - f), f = null;
  }
  return a.connect = function (e, t, n) {
    m = e, h = t, y = {};
    var _loop3 = function _loop3(_e10) {
      y[_e10] = function (t) {
        g = !1, C(!0), n[_e10] && n[_e10](t);
      };
    };
    for (var _e10 in n || {}) {
      _loop3(_e10);
    }
    E();
  }, a.disconnect = function () {
    clearTimeout(p), p = null, x();
  }, a.isConnected = function () {
    return !!(v && e.eventSourceIsActive && e.eventSourceIsActive(v));
  }, a;
};
var Be = function Be(e) {
  var t, n, r, o;
  var i = {
    addPromise: function addPromise(i, a) {
      t = i, n && n(), n = a, i.then(function (n) {
        t === i && (r(n), e && e());
      }, function (n) {
        t === i && (o(n), e && e());
      });
    }
  };
  return i.resultPromise = new Promise(function (e, t) {
    r = e, o = t;
  }), i;
};
var Ge = ge.transformHeaders,
  We = ge.getLDHeaders,
  Xe = "application/json";
var Qe = function Qe(e, t, n) {
  var r = t.baseUrl,
    o = t.useReport,
    i = t.evaluationReasons,
    a = t.logger,
    c = {},
    u = {};
  function l(n, r) {
    if (!e.httpRequest) return new Promise(function (e, t) {
      t(new s.LDFlagFetchError(ie.httpUnavailable()));
    });
    var o = r ? "REPORT" : "GET",
      i = We(e, t);
    r && (i["Content-Type"] = Xe);
    var a = u[n];
    a || (a = Be(function () {
      delete u[n];
    }), u[n] = a);
    var c = e.httpRequest(o, n, Ge(i, t), r),
      l = c.promise.then(function (e) {
        if (200 === e.status) {
          if (e.header("content-type") && e.header("content-type").substring(0, 16) === Xe) return JSON.parse(e.body);
          {
            var _t7 = ie.invalidContentType(e.header("content-type") || "");
            return Promise.reject(new s.LDFlagFetchError(_t7));
          }
        }
        return Promise.reject(function (e) {
          return 404 === e.status ? new s.LDInvalidEnvironmentIdError(ie.environmentNotFound()) : new s.LDFlagFetchError(ie.errorFetchingFlags(e.statusText || String(e.status)));
        }(e));
      }, function (e) {
        return Promise.reject(new s.LDFlagFetchError(ie.networkError(e)));
      });
    return a.addPromise(l, function () {
      c.cancel && c.cancel();
    }), a.resultPromise;
  }
  return c.fetchJSON = function (e) {
    return l(S.appendUrlPath(r, e), null);
  }, c.fetchFlagSettings = function (e, t) {
    var s,
      c,
      u,
      d = "";
    return o ? (c = [r, "/sdk/evalx/", n, "/context"].join(""), u = JSON.stringify(e)) : (s = S.base64URLEncode(JSON.stringify(e)), c = [r, "/sdk/evalx/", n, "/contexts/", s].join("")), t && (d = "h=" + t), i && (d = d + (d ? "&" : "") + "withReasons=true"), c = c + (d ? "?" : "") + d, a.debug(ie.debugPolling(c)), l(c, u);
  }, c;
};
var Ye = function Ye(e, t) {
  var n = {};
  var r;
  return n.setContext = function (e) {
    r = S.sanitizeContext(e), r && t && t(S.clone(r));
  }, n.getContext = function () {
    return r ? S.clone(r) : null;
  }, e && n.setContext(e), n;
};
var Ze = ee.v1,
  et = ke.getContextKinds;
var tt = function tt(e) {
  function t(e) {
    return null == e || "user" === e ? "ld:$anonUserId" : "ld:$contextKey:".concat(e);
  }
  function n(n, r) {
    return null !== r.key && void 0 !== r.key ? (r.key = r.key.toString(), Promise.resolve(r)) : r.anonymous ? function (n) {
      return e.get(t(n));
    }(n).then(function (o) {
      if (o) return r.key = o, r;
      {
        var _o6 = Ze();
        return r.key = _o6, function (n, r) {
          return e.set(t(r), n);
        }(_o6, n).then(function () {
          return r;
        });
      }
    }) : Promise.reject(new s.LDInvalidUserError(ie.invalidContext()));
  }
  this.processContext = function (e) {
    if (!e) return Promise.reject(new s.LDInvalidUserError(ie.contextNotSpecified()));
    var t = S.clone(e);
    if ("multi" === e.kind) {
      var _e11 = et(t);
      return Promise.all(_e11.map(function (e) {
        return n(e, t[e]);
      })).then(function () {
        return t;
      });
    }
    return n(e.kind, t);
  };
};
var nt = ee.v1,
  rt = de.baseOptionDefs,
  ot = S.appendUrlPath;
var it = {
  DiagnosticId: function DiagnosticId(e) {
    var t = {
      diagnosticId: nt()
    };
    return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
  },
  DiagnosticsAccumulator: function DiagnosticsAccumulator(e) {
    var t, n, r, o;
    function i(e) {
      t = e, n = 0, r = 0, o = [];
    }
    return i(e), {
      getProps: function getProps() {
        return {
          dataSinceDate: t,
          droppedEvents: n,
          eventsInLastBatch: r,
          streamInits: o
        };
      },
      setProps: function setProps(e) {
        t = e.dataSinceDate, n = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
      },
      incrementDroppedEvents: function incrementDroppedEvents() {
        n++;
      },
      setEventsInLastBatch: function setEventsInLastBatch(e) {
        r = e;
      },
      recordStreamInit: function recordStreamInit(e, t, n) {
        var r = {
          timestamp: e,
          failed: t,
          durationMillis: n
        };
        o.push(r);
      },
      reset: i
    };
  },
  DiagnosticsManager: function DiagnosticsManager(e, t, n, r, o, i, a) {
    var s = !!e.diagnosticUseCombinedEvent,
      c = "ld:" + o + ":$diagnostics",
      u = ot(i.eventsUrl, "/events/diagnostic/" + o),
      l = i.diagnosticRecordingInterval,
      d = n;
    var f,
      g,
      v = !!i.streaming;
    var p = {};
    function m() {
      return {
        sdk: w(),
        configuration: b(),
        platform: e.diagnosticPlatformData
      };
    }
    function h(e) {
      i.logger && i.logger.debug(ie.debugPostingDiagnosticEvent(e)), r.sendEvents(e, u, !0).then(function () {}).catch(function () {});
    }
    function y() {
      h(function () {
        var e = new Date().getTime();
        var t = _objectSpread({
          kind: s ? "diagnostic-combined" : "diagnostic",
          id: a,
          creationDate: e
        }, d.getProps());
        return s && (t = _objectSpread(_objectSpread({}, t), m())), d.reset(e), t;
      }()), g = setTimeout(y, l), f = new Date().getTime(), s && function () {
        if (t.isEnabled()) {
          var _e12 = _objectSpread({}, d.getProps());
          t.set(c, JSON.stringify(_e12));
        }
      }();
    }
    function w() {
      var t = _objectSpread({}, e.diagnosticSdkData);
      return i.wrapperName && (t.wrapperName = i.wrapperName), i.wrapperVersion && (t.wrapperVersion = i.wrapperVersion), t;
    }
    function b() {
      return {
        customBaseURI: i.baseUrl !== rt.baseUrl.default,
        customStreamURI: i.streamUrl !== rt.streamUrl.default,
        customEventsURI: i.eventsUrl !== rt.eventsUrl.default,
        eventsCapacity: i.eventCapacity,
        eventsFlushIntervalMillis: i.flushInterval,
        reconnectTimeMillis: i.streamReconnectDelay,
        streamingDisabled: !v,
        allAttributesPrivate: !!i.allAttributesPrivate,
        diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval,
        usingSecureMode: !!i.hash,
        bootstrapMode: !!i.bootstrap,
        fetchGoalsDisabled: !i.fetchGoals,
        sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation
      };
    }
    return p.start = function () {
      s ? function (e) {
        if (!t.isEnabled()) return e(!1);
        t.get(c).then(function (t) {
          if (t) try {
            var _e13 = JSON.parse(t);
            d.setProps(_e13), f = _e13.dataSinceDate;
          } catch (e) {}
          e(!0);
        }).catch(function () {
          e(!1);
        });
      }(function (e) {
        if (e) {
          var _e14 = (f || 0) + l,
            _t8 = new Date().getTime();
          _t8 >= _e14 ? y() : g = setTimeout(y, _e14 - _t8);
        } else 0 === Math.floor(4 * Math.random()) ? y() : g = setTimeout(y, l);
      }) : (h(_objectSpread({
        kind: "diagnostic-init",
        id: a,
        creationDate: d.getProps().dataSinceDate
      }, m())), g = setTimeout(y, l));
    }, p.stop = function () {
      g && clearTimeout(g);
    }, p.setStreaming = function (e) {
      v = e;
    }, p;
  }
};
var at = function at(e, t) {
  var n = !1;
  var r = {
    type: e.type,
    name: e.name,
    synchronous: e.synchronous,
    method: function method() {
      try {
        e.method.apply(e, arguments);
      } catch (_unused) {
        n || (n = !0, t.warn(ie.inspectorMethodError(r.type, r.name)));
      }
    }
  };
  return r;
};
var st = S.onNextTick,
  ct = {
    flagUsed: "flag-used",
    flagDetailsChanged: "flag-details-changed",
    flagDetailChanged: "flag-detail-changed",
    clientIdentityChanged: "client-identity-changed"
  };
Object.freeze(ct);
var ut = {
  InspectorTypes: ct,
  InspectorManager: function InspectorManager(e, t) {
    var n = {},
      r = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ct.flagUsed, []), ct.flagDetailsChanged, []), ct.flagDetailChanged, []), ct.clientIdentityChanged, []),
      o = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ct.flagUsed, []), ct.flagDetailsChanged, []), ct.flagDetailChanged, []), ct.clientIdentityChanged, []),
      i = e && e.map(function (e) {
        return at(e, t);
      });
    return i && i.forEach(function (e) {
      Object.prototype.hasOwnProperty.call(r, e.type) && !e.synchronous ? r[e.type].push(e) : Object.prototype.hasOwnProperty.call(o, e.type) && e.synchronous ? o[e.type].push(e) : t.warn(ie.invalidInspector(e.type, e.name));
    }), n.hasListeners = function (e) {
      return r[e] && r[e].length || o[e] && o[e].length;
    }, n.onFlagUsed = function (e, t, n) {
      var i = ct.flagUsed;
      o[i].length && o[i].forEach(function (r) {
        return r.method(e, t, n);
      }), r[i].length && st(function () {
        r[i].forEach(function (r) {
          return r.method(e, t, n);
        });
      });
    }, n.onFlags = function (e) {
      var t = ct.flagDetailsChanged;
      o[t].length && o[t].forEach(function (t) {
        return t.method(e);
      }), r[t].length && st(function () {
        r[t].forEach(function (t) {
          return t.method(e);
        });
      });
    }, n.onFlagChanged = function (e, t) {
      var n = ct.flagDetailChanged;
      o[n].length && o[n].forEach(function (n) {
        return n.method(e, t);
      }), r[n].length && st(function () {
        r[n].forEach(function (n) {
          return n.method(e, t);
        });
      });
    }, n.onIdentityChanged = function (e) {
      var t = ct.clientIdentityChanged;
      o[t].length && o[t].forEach(function (t) {
        return t.method(e);
      }), r[t].length && st(function () {
        r[t].forEach(function (t) {
          return t.method(e);
        });
      });
    }, n;
  }
};
var lt = s.LDTimeoutError;
var dt = function dt(e, t) {
  return new Promise(function (n, r) {
    setTimeout(function () {
      r(new lt("".concat(t, " timed out after ").concat(e, " seconds.")));
    }, 1e3 * e);
  });
};
var ft = ne.commonBasicLogger,
  gt = ke.checkContext,
  vt = ke.getContextKeys,
  pt = ut.InspectorTypes,
  mt = ut.InspectorManager,
  ht = "change",
  yt = "internal-change";
var wt = {
    initialize: function initialize(e, t, n, r, o) {
      var i = function () {
          if (n && n.logger) return n.logger;
          return o && o.logger && o.logger.default || ft("warn");
        }(),
        a = Re(i),
        c = Ne(a),
        u = de.validate(n, a, o, i),
        l = mt(u.inspectors, i),
        d = u.sendEvents;
      var f = e,
        g = u.hash;
      var v = Ve(r.localStorage, i),
        p = he(r, f, u),
        m = u.sendEvents && !u.diagnosticOptOut,
        h = m ? it.DiagnosticId(f) : null,
        y = m ? it.DiagnosticsAccumulator(new Date().getTime()) : null,
        w = m ? it.DiagnosticsManager(r, v, y, p, f, u, h) : null,
        b = Je(r, u, f, y),
        k = u.eventProcessor || Ue(r, u, f, y, a, p),
        E = Qe(r, u, f);
      var D,
        x,
        C,
        P = {},
        I = u.streaming,
        O = !1,
        T = !1,
        L = !0;
      var U = u.stateProvider,
        R = Ye(null, function (e) {
          (function (e) {
            if (U) return;
            e && F({
              kind: "identify",
              context: e,
              creationDate: new Date().getTime()
            });
          })(e), l.hasListeners(pt.clientIdentityChanged) && l.onIdentityChanged(R.getContext());
        }),
        A = new tt(v),
        j = v.isEnabled() ? $e(v, f, g, R) : null;
      function F(e) {
        f && (U && U.enqueueEvent && U.enqueueEvent(e) || (e.context ? (L = !1, !d || T || r.isDoNotTrack() || (i.debug(ie.debugEnqueueingEvent(e.kind)), k.enqueue(e))) : L && (i.warn(ie.eventWithoutContext()), L = !1)));
      }
      function N(e, t) {
        l.hasListeners(pt.flagDetailChanged) && l.onFlagChanged(e.key, q(t));
      }
      function $() {
        l.hasListeners(pt.flagDetailsChanged) && l.onFlags(Object.entries(P).map(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            e = _ref6[0],
            t = _ref6[1];
          return {
            key: e,
            detail: q(t)
          };
        }).reduce(function (e, t) {
          return e[t.key] = t.detail, e;
        }, {}));
      }
      function V(e, t, n, r) {
        var o = R.getContext(),
          i = new Date(),
          a = {
            kind: "feature",
            key: e,
            context: o,
            value: t ? t.value : null,
            variation: t ? t.variationIndex : null,
            default: n,
            creationDate: i.getTime()
          },
          s = P[e];
        s && (a.version = s.flagVersion ? s.flagVersion : s.version, a.trackEvents = s.trackEvents, a.debugEventsUntilDate = s.debugEventsUntilDate), (r || s && s.trackReason) && t && (a.reason = t.reason), F(a);
      }
      function M(e) {
        return gt(e, !1) ? Promise.resolve(e) : Promise.reject(new s.LDInvalidUserError(ie.invalidContext()));
      }
      function H(e, t, n, r, o) {
        var i;
        if (P && S.objectHasOwnProperty(P, e) && P[e] && !P[e].deleted) {
          var _n13 = P[e];
          i = q(_n13), null !== _n13.value && void 0 !== _n13.value || (i.value = t);
        } else i = {
          value: t,
          variationIndex: null,
          reason: {
            kind: "ERROR",
            errorKind: "FLAG_NOT_FOUND"
          }
        };
        return n && V(e, i, t, r), o || function (e, t) {
          l.hasListeners(pt.flagUsed) && l.onFlagUsed(e, t, R.getContext());
        }(e, i), i;
      }
      function q(e) {
        return {
          value: e.value,
          variationIndex: void 0 === e.variation ? null : e.variation,
          reason: e.reason || null
        };
      }
      function z() {
        if (x = !0, !R.getContext()) return;
        var e = function e(_e15) {
          try {
            return JSON.parse(_e15);
          } catch (e) {
            return void a.maybeReportError(new s.LDInvalidDataError(ie.invalidData()));
          }
        };
        b.connect(R.getContext(), g, {
          ping: function ping() {
            i.debug(ie.debugStreamPing());
            var e = R.getContext();
            E.fetchFlagSettings(e, g).then(function (t) {
              S.deepEquals(e, R.getContext()) && _(t || {});
            }).catch(function (e) {
              a.maybeReportError(new s.LDFlagFetchError(ie.errorFetchingFlags(e)));
            });
          },
          put: function put(t) {
            var n = e(t.data);
            n && (i.debug(ie.debugStreamPut()), _(n));
          },
          patch: function patch(t) {
            var n = e(t.data);
            if (!n) return;
            var r = P[n.key];
            if (!r || !r.version || !n.version || r.version < n.version) {
              i.debug(ie.debugStreamPatch(n.key));
              var _e16 = {},
                _t9 = S.extend({}, n);
              delete _t9.key, P[n.key] = _t9;
              var _o7 = q(_t9);
              _e16[n.key] = r ? {
                previous: r.value,
                current: _o7
              } : {
                current: _o7
              }, N(n, _t9), J(_e16);
            } else i.debug(ie.debugStreamPatchIgnored(n.key));
          },
          delete: function _delete(t) {
            var n = e(t.data);
            if (n) if (!P[n.key] || P[n.key].version < n.version) {
              i.debug(ie.debugStreamDelete(n.key));
              var _e17 = {};
              P[n.key] && !P[n.key].deleted && (_e17[n.key] = {
                previous: P[n.key].value
              }), P[n.key] = {
                version: n.version,
                deleted: !0
              }, N(n, P[n.key]), J(_e17);
            } else i.debug(ie.debugStreamDeleteIgnored(n.key));
          }
        });
      }
      function K() {
        x && (b.disconnect(), x = !1);
      }
      function _(e) {
        var t = {};
        if (!e) return Promise.resolve();
        for (var _n14 in P) S.objectHasOwnProperty(P, _n14) && P[_n14] && (e[_n14] && !S.deepEquals(e[_n14].value, P[_n14].value) ? t[_n14] = {
          previous: P[_n14].value,
          current: q(e[_n14])
        } : e[_n14] && !e[_n14].deleted || (t[_n14] = {
          previous: P[_n14].value
        }));
        for (var _n15 in e) S.objectHasOwnProperty(e, _n15) && e[_n15] && (!P[_n15] || P[_n15].deleted) && (t[_n15] = {
          current: q(e[_n15])
        });
        return P = _objectSpread({}, e), $(), J(t).catch(function () {});
      }
      function J(e) {
        var t = Object.keys(e);
        if (t.length > 0) {
          var _n16 = {};
          t.forEach(function (t) {
            var r = e[t].current,
              o = r ? r.value : void 0,
              i = e[t].previous;
            a.emit(ht + ":" + t, o, i), _n16[t] = r ? {
              current: o,
              previous: i
            } : {
              previous: i
            };
          }), a.emit(ht, _n16), a.emit(yt, P), u.sendEventsOnlyForVariation || U || t.forEach(function (t) {
            V(t, e[t].current);
          });
        }
        return D && j ? j.saveFlags(P) : Promise.resolve();
      }
      function B() {
        var e = I || C && void 0 === I;
        e && !x ? z() : !e && x && K(), w && w.setStreaming(e);
      }
      function G(e) {
        return e === ht || e.substr(0, 7) === ht + ":";
      }
      if ("string" == typeof u.bootstrap && "LOCALSTORAGE" === u.bootstrap.toUpperCase() && (j ? D = !0 : i.warn(ie.localStorageUnavailable())), "object" == typeof u.bootstrap && (P = function (e) {
        var t = Object.keys(e),
          n = "$flagsState",
          r = "$valid",
          o = e[n];
        !o && t.length && i.warn(ie.bootstrapOldFormat()), !1 === e[r] && i.warn(ie.bootstrapInvalid());
        var a = {};
        return t.forEach(function (t) {
          if (t !== n && t !== r) {
            var _n17 = {
              value: e[t]
            };
            o && o[t] ? _n17 = S.extend(_n17, o[t]) : _n17.version = 0, a[t] = _n17;
          }
        }), a;
      }(u.bootstrap)), U) {
        var _e18 = U.getInitialState();
        _e18 ? W(_e18) : U.on("init", W), U.on("update", function (e) {
          e.context && R.setContext(e.context);
          e.flags && _(e.flags);
        });
      } else (function () {
        if (!e) return Promise.reject(new s.LDInvalidEnvironmentIdError(ie.environmentNotSpecified()));
        return A.processContext(t).then(M).then(function (e) {
          return R.setContext(e), "object" == typeof u.bootstrap ? X() : D ? j.loadFlags().then(function (e) {
            return null == e ? (P = {}, E.fetchFlagSettings(R.getContext(), g).then(function (e) {
              return _(e || {});
            }).then(X).catch(function (e) {
              Q(new s.LDFlagFetchError(ie.errorFetchingFlags(e)));
            })) : (P = e, S.onNextTick(X), E.fetchFlagSettings(R.getContext(), g).then(function (e) {
              return _(e);
            }).catch(function (e) {
              return a.maybeReportError(e);
            }));
          }) : E.fetchFlagSettings(R.getContext(), g).then(function (e) {
            P = e || {}, $(), X();
          }).catch(function (e) {
            P = {}, Q(e);
          });
        });
      })().catch(Q);
      function W(e) {
        f = e.environment, R.setContext(e.context), P = _objectSpread({}, e.flags), S.onNextTick(X);
      }
      function X() {
        i.info(ie.clientInitialized()), O = !0, B(), c.signalSuccess();
      }
      function Q(e) {
        c.signalFailure(e);
      }
      var Y = {
        waitForInitialization: function waitForInitialization() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;
          if (null != e) {
            if ("number" == typeof e) return function (e) {
              e > 5 && i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
              var t = c.getInitializationPromise(),
                n = dt(e, "waitForInitialization");
              return Promise.race([n, t]).catch(function (e) {
                throw e instanceof s.LDTimeoutError && i.error("waitForInitialization error: ".concat(e)), e;
              });
            }(e);
            i.warn("The waitForInitialization method was provided with a non-numeric timeout.");
          }
          return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), c.getInitializationPromise();
        },
        waitUntilReady: function waitUntilReady() {
          return c.getReadyPromise();
        },
        identify: function identify(e, t, n) {
          if (T) return S.wrapPromiseCallback(Promise.resolve({}), n);
          if (U) return i.warn(ie.identifyDisabled()), S.wrapPromiseCallback(Promise.resolve(S.transformVersionedValuesToValues(P)), n);
          var r = D && j ? j.clearFlags() : Promise.resolve();
          return S.wrapPromiseCallback(r.then(function () {
            return A.processContext(e);
          }).then(M).then(function (e) {
            return E.fetchFlagSettings(e, t).then(function (n) {
              var r = S.transformVersionedValuesToValues(n);
              return R.setContext(e), g = t, n ? _(n).then(function () {
                return r;
              }) : r;
            });
          }).then(function (e) {
            return x && z(), e;
          }).catch(function (e) {
            return a.maybeReportError(e), Promise.reject(e);
          }), n);
        },
        getContext: function getContext() {
          return R.getContext();
        },
        variation: function variation(e, t) {
          return H(e, t, !0, !1, !1).value;
        },
        variationDetail: function variationDetail(e, t) {
          return H(e, t, !0, !0, !1);
        },
        track: function track(e, t, n) {
          if ("string" != typeof e) return void a.maybeReportError(new s.LDInvalidEventKeyError(ie.unknownCustomEventKey(e)));
          void 0 !== n && "number" != typeof n && i.warn(ie.invalidMetricValue(typeof n)), r.customEventFilter && !r.customEventFilter(e) && i.warn(ie.unknownCustomEventKey(e));
          var o = R.getContext(),
            c = {
              kind: "custom",
              key: e,
              context: o,
              url: r.getCurrentUrl(),
              creationDate: new Date().getTime()
            };
          o && o.anonymous && (c.contextKind = o.anonymous ? "anonymousUser" : "user"), null != t && (c.data = t), null != n && (c.metricValue = n), F(c);
        },
        on: function on(e, t, n) {
          G(e) ? (C = !0, O && B(), a.on(e, t, n)) : a.on.apply(a, arguments);
        },
        off: function off(e) {
          if (a.off.apply(a, arguments), G(e)) {
            var _e19 = !1;
            a.getEvents().forEach(function (t) {
              G(t) && a.getEventListenerCount(t) > 0 && (_e19 = !0);
            }), _e19 || (C = !1, x && void 0 === I && K());
          }
        },
        setStreaming: function setStreaming(e) {
          var t = null === e ? void 0 : e;
          t !== I && (I = t, B());
        },
        flush: function flush(e) {
          return S.wrapPromiseCallback(d ? k.flush() : Promise.resolve(), e);
        },
        allFlags: function allFlags() {
          var e = {};
          if (!P) return e;
          for (var _t10 in P) S.objectHasOwnProperty(P, _t10) && !P[_t10].deleted && (e[_t10] = H(_t10, null, !u.sendEventsOnlyForVariation, !1, !0).value);
          return e;
        },
        close: function close(e) {
          if (T) return S.wrapPromiseCallback(Promise.resolve(), e);
          var t = function t() {
              T = !0, P = {};
            },
            n = Promise.resolve().then(function () {
              if (K(), w && w.stop(), d) return k.stop(), k.flush();
            }).then(t).catch(t);
          return S.wrapPromiseCallback(n, e);
        }
      };
      return {
        client: Y,
        options: u,
        emitter: a,
        ident: R,
        logger: i,
        requestor: E,
        start: function start() {
          d && (w && w.start(), k.start());
        },
        enqueueEvent: F,
        getFlagsInternal: function getFlagsInternal() {
          return P;
        },
        getEnvironmentId: function getEnvironmentId() {
          return f;
        },
        internalChangeEventName: yt
      };
    },
    commonBasicLogger: ft,
    errors: s,
    messages: ie,
    utils: S,
    getContextKeys: vt
  },
  bt = wt.initialize,
  kt = wt.errors,
  Et = wt.messages;
function Dt(e, t, n) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || !e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" != typeof r) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof t ? t : t + "";
  }(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function xt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ct(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? xt(Object(n), !0).forEach(function (t) {
      Dt(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xt(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
var Pt = wt.commonBasicLogger;
var St = function St(e) {
  return Pt(Ct({
    destination: console.log
  }, e));
};
var It = {
  promise: Promise.resolve({
    status: 200,
    header: function header() {
      return null;
    },
    body: null
  })
};
function Ot(e, t, n, r, o) {
  if (o && !function () {
    var e = window.navigator && window.navigator.userAgent;
    if (e) {
      var t = e.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (t) return parseInt(t[2], 10) < 73;
    }
    return !0;
  }()) return It;
  var i = new window.XMLHttpRequest();
  for (var a in i.open(e, t, !o), n || {}) Object.prototype.hasOwnProperty.call(n, a) && i.setRequestHeader(a, n[a]);
  if (o) {
    try {
      i.send(r);
    } catch (e) {}
    return It;
  }
  var s,
    c = new Promise(function (e, t) {
      i.addEventListener("load", function () {
        s || e({
          status: i.status,
          header: function header(e) {
            return i.getResponseHeader(e);
          },
          body: i.responseText
        });
      }), i.addEventListener("error", function () {
        s || t(new Error());
      }), i.send(r);
    });
  return {
    promise: c,
    cancel: function cancel() {
      s = !0, i.abort();
    }
  };
}
var Tt = function Tt(e) {
  if ("string" != typeof e) throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function Lt(e, t, n, r) {
  var o,
    i,
    a = (("substring" === e.kind || "regex" === e.kind) && r.includes("/") ? t : t.replace(r, "")).replace(n, "");
  switch (e.kind) {
    case "exact":
      i = t, o = new RegExp("^" + Tt(e.url) + "/?$");
      break;
    case "canonical":
      i = a, o = new RegExp("^" + Tt(e.url) + "/?$");
      break;
    case "substring":
      i = a, o = new RegExp(".*" + Tt(e.substring) + ".*$");
      break;
    case "regex":
      i = a, o = new RegExp(e.pattern);
      break;
    default:
      return !1;
  }
  return o.test(i);
}
function Ut(e, t) {
  for (var n = {}, r = null, o = [], i = 0; i < e.length; i++) for (var a = e[i], s = a.urls || [], c = 0; c < s.length; c++) if (Lt(s[c], window.location.href, window.location.search, window.location.hash)) {
    "pageview" === a.kind ? t("pageview", a) : (o.push(a), t("click_pageview", a));
    break;
  }
  return o.length > 0 && (r = function r(e) {
    for (var n = function (e, t) {
        for (var n = [], r = 0; r < t.length; r++) for (var o = e.target, i = t[r], a = i.selector, s = document.querySelectorAll(a); o && s.length > 0;) {
          for (var c = 0; c < s.length; c++) o === s[c] && n.push(i);
          o = o.parentNode;
        }
        return n;
      }(e, o), r = 0; r < n.length; r++) t("click", n[r]);
  }, document.addEventListener("click", r)), n.dispose = function () {
    document.removeEventListener("click", r);
  }, n;
}
var Rt = 300;
function At(e, t) {
  var n, r;
  function o() {
    r && r.dispose(), n && n.length && (r = Ut(n, i));
  }
  function i(t, n) {
    var r = e.ident.getContext(),
      o = {
        kind: t,
        key: n.key,
        data: null,
        url: window.location.href,
        creationDate: new Date().getTime(),
        context: r
      };
    return "click" === t && (o.selector = n.selector), e.enqueueEvent(o);
  }
  return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function (e) {
    e && e.length > 0 && (r = Ut(n = e, i), function (e, t) {
      var n,
        r = window.location.href;
      function o() {
        (n = window.location.href) !== r && (r = n, t());
      }
      !function e(t, n) {
        t(), setTimeout(function () {
          e(t, n);
        }, n);
      }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
    }(Rt, o)), t();
  }).catch(function (n) {
    e.emitter.maybeReportError(new kt.LDUnexpectedResponseError((n && n.message, n.message))), t();
  }), {};
}
var jt = "goalsReady",
  Ft = {
    fetchGoals: {
      default: !0
    },
    hash: {
      type: "string"
    },
    eventProcessor: {
      type: "object"
    },
    eventUrlTransformer: {
      type: "function"
    },
    disableSyncEventPost: {
      default: !1
    }
  };
function Nt(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    r = function (e) {
      var t,
        n = {
          userAgentHeaderName: "X-LaunchDarkly-User-Agent",
          synchronousFlush: !1
        };
      if (window.XMLHttpRequest) {
        var r = e && e.disableSyncEventPost;
        n.httpRequest = function (e, t, o, i) {
          var a = n.synchronousFlush & !r;
          return n.synchronousFlush = !1, Ot(e, t, o, i, a);
        };
      }
      n.httpAllowsPost = function () {
        return void 0 === t && (t = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), t;
      }, n.httpFallbackPing = function (e) {
        new window.Image().src = e;
      };
      var o,
        i = e && e.eventUrlTransformer;
      n.getCurrentUrl = function () {
        return i ? i(window.location.href) : window.location.href;
      }, n.isDoNotTrack = function () {
        var e;
        return 1 === (e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === e || "1" === e || "yes" === e;
      };
      try {
        window.localStorage && (n.localStorage = {
          get: function get(e) {
            return new Promise(function (t) {
              t(window.localStorage.getItem(e));
            });
          },
          set: function set(e, t) {
            return new Promise(function (n) {
              window.localStorage.setItem(e, t), n();
            });
          },
          clear: function clear(e) {
            return new Promise(function (t) {
              window.localStorage.removeItem(e), t();
            });
          }
        });
      } catch (e) {
        n.localStorage = null;
      }
      if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (n.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (n.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
        var a = 3e5;
        n.eventSourceFactory = function (e, t) {
          var n = Ct(Ct({}, {
            heartbeatTimeout: a,
            silentTimeout: a,
            skipDefaultHeaders: !0
          }), t);
          return new o(e, n);
        }, n.eventSourceIsActive = function (e) {
          return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
        };
      }
      return n.userAgent = "JSClient", n.version = "3.4.0", n.diagnosticSdkData = {
        name: "js-client-sdk",
        version: "3.4.0"
      }, n.diagnosticPlatformData = {
        name: "JS"
      }, n.diagnosticUseCombinedEvent = !0, n;
    }(n),
    o = bt(e, t, n, r, Ft),
    i = o.client,
    a = o.options,
    s = o.emitter,
    c = new Promise(function (e) {
      var t = s.on(jt, function () {
        s.off(jt, t), e();
      });
    });
  i.waitUntilGoalsReady = function () {
    return c;
  }, a.fetchGoals ? At(o, function () {
    return s.emit(jt);
  }) : s.emit(jt), "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();
  var u = function u() {
    r.synchronousFlush = !0, i.flush().catch(function () {}), r.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function () {
    "hidden" === document.visibilityState && u();
  }), window.addEventListener("pagehide", u), i;
}
var $t = St,
  Vt = void 0,
  Mt = "3.4.0";
var Ht = {
  initialize: function initialize(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return console && console.warn && console.warn(Et.deprecated("default export", "named LDClient export")), Nt(e, t, n);
  },
  version: Mt
};
export { $t as basicLogger, Vt as createConsoleLogger, Ht as default, Nt as initialize, Mt as version };